import { ResourceOptions } from 'react-admin';
import { FaFlask, FaGift, FaGlassCheers, FaHorse } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './Overview';

export const name = Resources.redpacketOverview;
export const icon = FaHorse;
export const options: ResourceOptions = {
  label: 'module.redpacket.overview',
};
